
<nx-pageTitle-box class="mb-3" [label]="'Gruppen'" [icon]="'icon-group'" [iconToolTip]="'Gruppen'"
  [bcRootLvlLabel]="'Einstellungen'"
  [bcRootLvlPath]="'settings'"
  [menuItems]="pageTitleMenuItems">
</nx-pageTitle-box>

<nx-table-header
  label="Gruppenliste">
  <ng-template nxTemplate="end">
    <nx-default-button
      (click)="createGroup()"
      [style]="'light'"
      [label]="'Gruppe hinzufügen'"
      [icon]="'icon-plus'">
    </nx-default-button>
  </ng-template>
</nx-table-header>

<p-table
  [lazy]="true"
  (onLazyLoad)="loadData($any($event))"
  [value]="dataSource?.data"
  [scrollable]="true"
  [paginator]="true"
  [rows]="15"
  [rowsPerPageOptions]="[15, 20, 50]"
  [totalRecords]="dataSource?.totalElements"
  [loading]="loading"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="{first} - {last} von {totalRecords}"
  [resizableColumns]="true">
  <ng-template pTemplate="header">
    <tr>
      <th>Name</th>
    </tr>
    </ng-template>
    <ng-template pTemplate="body" let-group>
      <tr class="clickable" (click)="openGroup(group)">
          <td>{{group.name}}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" class="emptyMessage">Keine Gruppen vorhanden.</td>
      </tr>
    </ng-template>
</p-table>